import * as React from 'react';
import {
  ResponsiveMode,
  setResponsiveMode,
  withResponsiveMode as withFabricResponsiveMode,
} from 'office-ui-fabric-react/lib/utilities/decorators/withResponsiveMode';

import { IComponentDecorator, IDecoratedProps } from '../../utilities/components/Decorators';

export { ResponsiveMode, setResponsiveMode };

export interface IWithResponsiveModeProps { }

export interface IResponsiveModeProps {
  responsiveMode?: ResponsiveMode;
}

export function withResponsiveMode(): IComponentDecorator<IResponsiveModeProps, IWithResponsiveModeProps> {
  return <P extends IResponsiveModeProps>(
    component: React.ComponentType<P>
  ): React.ComponentType<IDecoratedProps<P, IResponsiveModeProps, IWithResponsiveModeProps>> => {
    const Component = component;

    // @ts-ignore Need Exclude type from TypeScript 2.8.
    return withFabricResponsiveMode(Component);
  };
}
